import { render } from "./cnt-table_cause_groups.vue?vue&type=template&id=3952bf80&scoped=true"
const script = {}

import "./cnt-table_cause_groups.vue?vue&type=style&index=0&id=3952bf80&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3952bf80"]])

export default __exports__